/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Kindle_Scroll_ReaderInputs */

const en_mobile_kindle_scroll_reader = /** @type {(inputs: Mobile_Kindle_Scroll_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kindle scroll reader`)
};

const es_mobile_kindle_scroll_reader = /** @type {(inputs: Mobile_Kindle_Scroll_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lector Kindle con desplazamiento`)
};

/**
* | output |
* | --- |
* | "Kindle scroll reader" |
*
* @param {Mobile_Kindle_Scroll_ReaderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_kindle_scroll_reader = /** @type {((inputs?: Mobile_Kindle_Scroll_ReaderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Kindle_Scroll_ReaderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_kindle_scroll_reader(inputs)
	return en_mobile_kindle_scroll_reader(inputs)
});